import React from "react";
import { PriceType } from "state/types";

export interface MedicationPriceCardProps {
    medicationPricing?: PriceType;
    medicationRetailPricing?: PriceType;
}

const MedicationPriceCard = ({ medicationPricing: pricing,
                                 medicationRetailPricing: retailPricing }: MedicationPriceCardProps) => {
    const getPrice = () => {
        return `From \$${pricing?.amount} per pill`
    }

    return (
        <>
            <pui-section class="price-card">
                <pui-section flowDirection="horizontal"
                             mainAxisArrangement="start"
                             secondaryAxisArrangement="center">
                    <pui-text input={getPrice()} fontWeight="bold" textSize="double-extra-large"></pui-text>
                    <pui-icon spacingLeft="mini" imgClass="a-icon a-icon-prime a-icon-medium"></pui-icon>
                </pui-section>
                {retailPricing &&
                    <pui-section flowDirection="horizontal"
                                 mainAxisArrangement="start"
                                 secondaryAxisArrangement="center"
                                 spacingTop="mini">
                        <pui-text input="Retail price:" textSize="medium" textColor="grey"></pui-text>
                        <pui-text input={`\$${retailPricing.amount} per pill`} textSize="medium" textColor="grey" spacingLeft="mini"
                                  textDecorationLine="line-through"></pui-text>
                    </pui-section>
                }
            </pui-section>
        </>
    )
}

export default MedicationPriceCard;
